export interface RetryOption {
    label: string;
    value: {
        max_retry_count: number;
        min_retry_delay_seconds: number;
    };
}

export const RETRY_OPTIONS: RetryOption[] = [
    {
        label: 'dont_repeat',
        value: {
            max_retry_count: 0,
            min_retry_delay_seconds: 0,
        },
    },
    {
        label: 'once_after_ten_minutes',
        value: {
            max_retry_count: 1,
            min_retry_delay_seconds: 600,
        },
    },
    {
        label: 'once_after_one',
        value: {
            max_retry_count: 1,
            min_retry_delay_seconds: 3600,
        },
    },
    {
        label: 'once_after_two',
        value: {
            max_retry_count: 1,
            min_retry_delay_seconds: 7200,
        },
    },
    {
        label: 'once_after_three',
        value: {
            max_retry_count: 1,
            min_retry_delay_seconds: 10800,
        },
    },
    {
        label: 'once_after_four',
        value: {
            max_retry_count: 1,
            min_retry_delay_seconds: 14400,
        },
    },
    {
        label: 'twice_after_ten_minutes',
        value: {
            max_retry_count: 2,
            min_retry_delay_seconds: 600,
        },
    },
    {
        label: 'twice_after_one',
        value: {
            max_retry_count: 2,
            min_retry_delay_seconds: 3600,
        },
    },
    {
        label: 'twice_after_two',
        value: {
            max_retry_count: 2,
            min_retry_delay_seconds: 7200,
        },
    },
    {
        label: 'twice_after_three',
        value: {
            max_retry_count: 2,
            min_retry_delay_seconds: 10800,
        },
    },
    {
        label: 'twice_after_four',
        value: {
            max_retry_count: 2,
            min_retry_delay_seconds: 14400,
        },
    },
];
